import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";

export default function LogoutButton() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  return (
    <Button
      color="inherit"
      startIcon={<LogoutIcon />}
      onClick={handleLogout}
      sx={{ textTransform: "none", fontWeight: "bold" }}
    >
      Logout
    </Button>
  );
}
